import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ValuePropositionIcon = styled.div`
  ${tw`
    absolute
    flex
    items-center
    justify-center
    h-5
    w-5
    rounded-full
  `}
  color: #1FC763;
  background-color: #e9ffc3;
  svg {
    ${tw`
      h-2
      w-3
    `}
  }
`

export const ValuePropositionWrapper = styled.div`
  ${tw`
    flex
    flex-col
    mt-8
    space-y-3
    items-center
  `}
  p {
    ${tw`
      text-center
      text-sm
      text-purple-300
    `}
  }
`

export const ValuePropositionTitle = styled.div`
  ${tw`
    flex
    flex-row
  `}
  span {
    ${tw`
      text-lg
      lg:text-xl
      leading-6
      ml-7
      mb-1
      font-semibold
    `}
    color: #1FC763;
    white-space: normal;
  }
`
